import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import styles from "./arrow-button.module.scss";

type Props = {
  onClick: () => any;
};

const ArrowButtonRight = ({ onClick }: Props) => {
  return (
    <button onClick={onClick} className={styles.button}>
      <FaArrowRightLong />
    </button>
  );
};

export default ArrowButtonRight;
